export function BlockedBadge() {
  return (
    <span className="bg-red-100 text-red-700 px-1.5 py-0.5 rounded font-medium">
      Blocked
    </span>
  )
}
